import React from 'react';
export const PRIVACY_CONTENT = <>
    <p data-id="element-768">
      <strong data-id="element-769">1. Recopilación de Información</strong>
      <br data-id="element-770" />
      Recopilamos información cuando te registras en nuestro sitio, realizas una
      compra, o participas en el sitio. La información recopilada incluye tu
      nombre, dirección de correo electrónico y detalles de pago.
    </p>

    <p data-id="element-771">
      <strong data-id="element-772">2. Uso de la Información</strong>
      <br data-id="element-773" />
      Cualquier información que recopilemos de ti puede ser utilizada para:
      personalizar tu experiencia, mejorar nuestro sitio web, procesar
      transacciones y enviar correos electrónicos periódicos.
    </p>

    <p data-id="element-774">
      <strong data-id="element-775">3. Privacidad del Comercio Electrónico</strong>
      <br data-id="element-776" />
      Somos los únicos propietarios de la información recopilada en este sitio.
      Tu información personal no será vendida, intercambiada, transferida o dada
      a ninguna otra empresa por ningún motivo, sin tu consentimiento, excepto
      para el propósito expreso de entregar el producto adquirido.
    </p>

    <p data-id="element-777">
      <strong data-id="element-778">4. Píxel de Meta y Seguimiento</strong>
      <br data-id="element-779" />
      Utilizamos el Píxel de Meta (Facebook) y otras tecnologías de seguimiento
      para comprender cómo interactúas con nuestro sitio web y para optimizar
      nuestras campañas publicitarias. Esto nos permite mostrarte anuncios
      relevantes basados en tus intereses.
    </p>

    <p data-id="element-780">
      <strong data-id="element-781">5. Consentimiento</strong>
      <br data-id="element-782" />
      Al utilizar nuestro sitio, aceptas nuestra política de privacidad.
    </p>
  </>;
export const TERMS_CONTENT = <>
    <p data-id="element-783">
      <strong data-id="element-784">1. Aceptación de los Términos</strong>
      <br data-id="element-785" />
      Al acceder y utilizar este sitio web y adquirir "El Código 888", aceptas
      estar sujeto a estos Términos de Servicio y a todas las leyes y
      regulaciones aplicables.
    </p>

    <p data-id="element-786">
      <strong data-id="element-787">2. Naturaleza del Producto</strong>
      <br data-id="element-788" />
      "El Código 888" es un producto digital (audio y manual en PDF). Al
      realizar la compra, recibirás acceso inmediato para descargar o visualizar
      el contenido. No se enviará ningún producto físico.
    </p>

    <p data-id="element-789">
      <strong data-id="element-790">3. Política de Reembolsos</strong>
      <br data-id="element-791" />
      Debido a la naturaleza digital e inmediatamente accesible de este
      producto, todas las ventas son finales. No ofrecemos reembolsos una vez
      que el producto ha sido entregado digitalmente, a menos que la ley local
      exija lo contrario.
    </p>

    <p data-id="element-792">
      <strong data-id="element-793">4. Propiedad Intelectual</strong>
      <br data-id="element-794" />
      Todo el contenido incluido en este producto (textos, audios, gráficos,
      logotipos) es propiedad exclusiva de El Código 888. Queda estrictamente
      prohibida su reproducción, distribución o reventa sin autorización expresa
      por escrito.
    </p>

    <p data-id="element-795">
      <strong data-id="element-796">5. Exención de Responsabilidad</strong>
      <br data-id="element-797" />
      La información y los audios proporcionados tienen fines puramente
      educativos y de entretenimiento. No garantizamos resultados financieros
      específicos. Los testimonios mostrados son experiencias individuales y no
      constituyen una garantía de resultados similares. No somos asesores
      financieros ni médicos.
    </p>
  </>;